import { axiosInstance } from "./axiosInstance";

export const branchService = {
    getBranch: async (filter) => {
        return await axiosInstance.get('/api/superadmin/branch', { params: filter })
    },
    createBranch: async (data) => {
        return await axiosInstance.post('/api/superadmin/branch/create', data)
    },
    updateBranch: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/branch/update/${id}`, data)
    },
    deleteBranch: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/branch/delete/${id}`)
    },
    deleteBanner: async (id, pivotId) => {
        return await axiosInstance.delete(`/api/superadmin/branch/delete-banner/${id}/${pivotId}`)
    },
    attachTreatment: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/branch/attach-treatment/${id}`, data)
    },
    attachDoctor: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/branch/attach-doctor/${id}`, data)
    },
    getSetupSchedule: async (id) => {
        return await axiosInstance.get(`/api/superadmin/branch/setup-schedule/${id}`)
    },
    getBranchSchedule: async (id) => {
        return await axiosInstance.get(`/api/superadmin/branch/schedule/${id}`)
    }
}